import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_home/courses')({
  component: CoursesLayout,
})

function CoursesLayout() {
  return <Outlet />
}
